import { Injectable } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';

@Injectable({
  providedIn: 'root'
})
export class SeoService {

  constructor(
    private meta: Meta,
    private title: Title
  ) { }

  updateTitle(title: string): void {
    this.title.setTitle(title);
  }

  updateDescription(description: string): void {
    this.meta.updateTag({ name: 'description', content: description });
  }

  updateKeywords(keywords: string): void {
    this.meta.updateTag({ name: 'keywords', content: keywords });
  }

  updateOgTags(title: string, description: string, image?: string, url?: string): void {
    this.meta.updateTag({ property: 'og:title', content: title });
    this.meta.updateTag({ property: 'og:description', content: description });
    
    if (image) {
      this.meta.updateTag({ property: 'og:image', content: image });
    }
    
    if (url) {
      this.meta.updateTag({ property: 'og:url', content: url });
    }
  }

  updateTwitterTags(title: string, description: string, image?: string): void {
    this.meta.updateTag({ property: 'twitter:title', content: title });
    this.meta.updateTag({ property: 'twitter:description', content: description });
    
    if (image) {
      this.meta.updateTag({ property: 'twitter:image', content: image });
    }
  }

  updateCanonicalUrl(url: string): void {
    const canonical = document.querySelector('link[rel="canonical"]');
    if (canonical) {
      canonical.setAttribute('href', url);
    } else {
      const link = document.createElement('link');
      link.setAttribute('rel', 'canonical');
      link.setAttribute('href', url);
      document.head.appendChild(link);
    }
  }

  removeTag(tag: string): void {
    this.meta.removeTag(tag);
  }

  setDefaultSEO(): void {
    this.updateTitle('Insightful IT Services - Cloud & Managed IT Services in India | Enterprise Solutions');
    this.updateDescription('Leading provider of Cloud Services and Managed IT Solutions in India. Enterprise-grade infrastructure, 24/7 support, 99.9% uptime SLA. Specializing in Windows Cloud, Linux Cloud, GPU Cloud, and comprehensive managed IT services.');
    this.updateKeywords('Cloud Services India, Managed IT Services India, Windows Cloud Hosting, Linux Cloud Hosting, GPU Cloud Computing, Enterprise Cloud Solutions, Cloud Infrastructure India, Managed IT Support');
    
    this.updateOgTags(
      'Insightful IT Services - Cloud & Managed IT Services in India | Enterprise Solutions',
      'Leading provider of Cloud Services and Managed IT Solutions in India. Enterprise-grade infrastructure, 24/7 support, 99.9% uptime SLA. Specializing in Windows Cloud, Linux Cloud, GPU Cloud, and comprehensive managed IT services.'
    );
    
    this.updateTwitterTags(
      'Insightful IT Services - Cloud & Managed IT Services in India | Enterprise Solutions',
      'Leading provider of Cloud Services and Managed IT Solutions in India. Enterprise-grade infrastructure, 24/7 support, 99.9% uptime SLA. Specializing in Windows Cloud, Linux Cloud, GPU Cloud, and comprehensive managed IT services.'
    );
  }

  setSEOTags(title: string, description: string, keywords: string, image?: string, url?: string): void {
    // Update title
    const fullTitle = `${title} - Insightful IT Services`;
    this.updateTitle(fullTitle);
    
    // Update meta tags
    this.updateDescription(description);
    this.updateKeywords(keywords);
    
    // Update Open Graph tags
    this.updateOgTags(fullTitle, description, image, url);
    
    // Update Twitter tags
    this.updateTwitterTags(fullTitle, description, image);
    
    // Update canonical URL if provided
    if (url) {
      this.updateCanonicalUrl(url);
    }
  }

  setSEOTagsWithUrl(title: string, description: string, keywords: string, url: string): void {
    // Update title
    const fullTitle = `${title} - Insightful IT Services`;
    this.updateTitle(fullTitle);
    
    // Update meta tags
    this.updateDescription(description);
    this.updateKeywords(keywords);
    
    // Update Open Graph tags
    this.updateOgTags(fullTitle, description, undefined, url);
    
    // Update Twitter tags
    this.updateTwitterTags(fullTitle, description, undefined);
    
    // Update canonical URL
    this.updateCanonicalUrl(url);
  }
}